// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import gitBranch01Icon from "@/assets/icons/git-branch-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type GitBranch01IconProps = Omit<IconProps, "name">;

export function GitBranch01Icon(props: GitBranch01IconProps): React.ReactNode {
  return <Icon name={gitBranch01Icon} {...props} />;
}
